import type { ReactNode } from "react";
import { useHandsOnOrg } from "./handsOn";

/** Renders its children everywhere except the hands-on org. */
export function HideInHandsOn({ children }: { children: ReactNode }) {
  return useHandsOnOrg() ? null : <>{children}</>;
}
